<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'FOOTER.CAREERS_TITLE' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'FOOTER.CAREERS_TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'FOOTER.CAREERS_TEXT' | translate }}</p>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'FOOTER.CAREERS_WHY_JOIN_TITLE' | translate }}</h2>
      </div>
      <ul class="ph-careers-list">
        <li *ngFor="let item of whyJoinKeys">{{ item | translate }}</li>
      </ul>
    </div>
  </section>

  <section class="ph-section">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'FOOTER.CAREERS_OPEN_POSITIONS_TITLE' | translate }}</h2>
      </div>
      <div class="ph-careers-grid">
        <article *ngFor="let job of positions" class="ph-job-card">
          <h3>{{ job.titleKey | translate }}</h3>
          <p>{{ job.descKey | translate }}</p>
          <a [href]="careersMailto" class="ph-btn ph-btn--brand">{{ 'FOOTER.CAREERS_APPLY_NOW' | translate }}</a>
        </article>
      </div>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'FOOTER.CAREERS_BENEFITS_TITLE' | translate }}</h2>
      </div>
      <div class="ph-benefits-grid">
        <article *ngFor="let benefit of benefits" class="ph-benefit-card">
          <div class="ph-benefit-card__icon" aria-hidden="true"><i class="lni" [ngClass]="benefit.icon"></i></div>
          <h3 class="ph-benefit-card__title">{{ benefit.titleKey | translate }}</h3>
          <p class="ph-benefit-card__text">{{ benefit.descKey | translate }}</p>
        </article>
      </div>
    </div>
  </section>

  <section id="contact" class="ph-section">
    <div class="ph-container ph-container--narrow">
      <div class="ph-page-cta ph-careers-contact">
        <h2 class="ph-page-cta__title">{{ 'FOOTER.CAREERS_CONTACT_TITLE' | translate }}</h2>
        <p class="ph-page-cta__text">{{ 'FOOTER.CAREERS_CONTACT_TEXT' | translate }}</p>

        <div class="ph-careers-contact__email">
          <span class="ph-careers-contact__label">{{ 'FOOTER.CAREERS_CONTACT_EMAIL_LABEL' | translate }}</span>
          <a [href]="careersMailto" class="ph-careers-contact__link">{{ careersEmail }}</a>
        </div>

        <div class="ph-page-cta__actions">
          <a [href]="careersMailto" class="ph-btn ph-btn--brand ph-btn--lg">
            {{ 'FOOTER.CAREERS_CONTACT_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
  </section>
</div>
